<template>
  <div id="app" class="app-shell">
    <header class="site-header">
      <div class="container-lg site-header__inner">
        <div class="site-header__leading">
          <button
            v-if="showBackButton"
            class="site-header__back"
            type="button"
            title="返回上一页"
            aria-label="返回上一页"
            @click="handleBack"
          >
            <img class="site-header__back-icon" src="@/assets/houtui.png" alt="" aria-hidden="true">
          </button>

          <router-link class="brand" to="/">
            <div class="brand__logo">
              <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="40" rx="10" fill="url(#logo-gradient)"/>
                <path d="M12 14C12 12.8954 12.8954 12 14 12H18C19.1046 12 20 12.8954 20 14V26C20 27.1046 19.1046 28 18 28H14C12.8954 28 12 27.1046 12 26V14Z" fill="white"/>
                <path d="M22 18C22 16.8954 22.8954 16 24 16H26C27.1046 16 28 16.8954 28 18V26C28 27.1046 27.1046 28 26 28H24C22.8954 28 22 27.1046 22 26V18Z" fill="white" opacity="0.7"/>
                <defs>
                  <linearGradient id="logo-gradient" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#ff6b35"/>
                    <stop offset="1" stop-color="#ffa726"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div class="brand__text">
              <strong>Course Space</strong>
              <small>在线学习平台</small>
            </div>
          </router-link>
        </div>

        <button
          class="menu-toggle"
          type="button"
          :aria-expanded="String(mobileMenuOpen)"
          aria-label="切换导航菜单"
          @click="mobileMenuOpen = !mobileMenuOpen"
        >
          <span :class="{ 'is-open': mobileMenuOpen }"></span>
          <span :class="{ 'is-open': mobileMenuOpen }"></span>
          <span :class="{ 'is-open': mobileMenuOpen }"></span>
        </button>

        <nav :class="['site-nav', { 'is-open': mobileMenuOpen }]">
          <div class="site-nav__links">
            <router-link
              v-for="item in navigationLinks"
              :key="item.name"
              :to="item.to"
              class="site-nav__link"
              exact-active-class="is-active"
            >
              <i :class="item.icon"></i>
              <span>{{ item.label }}</span>
              <small
                v-if="item.name === 'notifications' && unreadNotificationCount > 0"
                class="site-nav__badge"
              >
                {{ unreadNotificationCount > 99 ? '99+' : unreadNotificationCount }}
              </small>
            </router-link>
          </div>

          <div class="site-nav__actions">
            <template v-if="!isAuthenticated">
              <router-link
                class="btn btn--ghost btn--sm"
                :to="{ name: 'login' }"
              >
                登录
              </router-link>
              <router-link
                class="btn btn--primary btn--sm"
                :to="{ name: 'register' }"
              >
                注册
              </router-link>
            </template>
            <template v-else>
              <router-link
                class="user-menu"
                :to="{ name: 'profile' }"
              >
                <div class="user-menu__avatar">
                  {{ displayNameInitial }}
                </div>
                <span class="user-menu__name">{{ displayName }}</span>
              </router-link>
              <button
                class="btn btn--ghost btn--sm"
                type="button"
                :disabled="actionPending"
                @click="handleLogout"
              >
                {{ actionPending ? '退出中...' : '退出' }}
              </button>
            </template>
          </div>
        </nav>
      </div>
    </header>

    <main class="site-main">
      <router-view />
    </main>

    <AuthModal
      :visible="authDialog.visible"
      :message="authDialog.message"
      @relogin="handleGlobalRelogin"
    />

    <!-- <footer class="site-footer">
      <div class="container">
        <div class="site-footer__content">
          <div class="site-footer__brand">
            <div class="brand__logo">
              <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="40" rx="10" fill="url(#footer-logo-gradient)"/>
                <path d="M12 14C12 12.8954 12.8954 12 14 12H18C19.1046 12 20 12.8954 20 14V26C20 27.1046 19.1046 28 18 28H14C12.8954 28 12 27.1046 12 26V14Z" fill="white"/>
                <path d="M22 18C22 16.8954 22.8954 16 24 16H26C27.1046 16 28 16.8954 28 18V26C28 27.1046 27.1046 28 26 28H24C22.8954 28 22 27.1046 22 26V18Z" fill="white" opacity="0.7"/>
                <defs>
                  <linearGradient id="footer-logo-gradient" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#ff6b35"/>
                    <stop offset="1" stop-color="#ffa726"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <p class="site-footer__desc">专注于提供优质的在线课程，助力每个人的学习成长之路。</p>
          </div>

          <div class="site-footer__links">
            <div class="footer-column">
              <div class="footer-column__links">
                <router-link to="/courses">全部课程</router-link>
                <router-link to="/courses">前端开发</router-link>
                <router-link to="/courses">后端开发</router-link>
                <router-link to="/courses">移动开发</router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="site-footer__bottom">
          <p>&copy; 2026 Course Space. All rights reserved.</p>
        </div>
      </div>
    </footer> -->
  </div>
</template>

<script>
import { logoutMember } from '@/api/auth'
import { fetchStudentSettings, hasStudentNavigation } from '@/api/student-settings'
import AuthModal from '@/components/AuthModal.vue'
import { authDialogState, hideAuthDialog, setAuthDialogRedirect, showAuthDialog } from '@/store/authDialog'
import { loadUnreadCount, notificationState, pollNotificationHasNew } from '@/store/notification'
import { clearSession, hydrateSession, sessionState } from '@/store/session'

export default {
  name: 'App',
  components: {
    AuthModal
  },
  data() {
    return {
      mobileMenuOpen: false,
      actionPending: false,
      unreadPollTimer: null,
      studentSettings: null,
      studentSettingsCourseId: 0
    }
  },
  computed: {
    authDialog() {
      return authDialogState
    },
    session() {
      return sessionState
    },
    isAuthenticated() {
      return Boolean(this.session.token)
    },
    showBackButton() {
      return this.$route.name !== 'home'
    },
    navigationLinks() {
      const links = [
        { name: 'home', label: '首页', to: { name: 'home' }, icon: 'icon-home' }
      ]

      if (hasStudentNavigation(this.studentSettings, ['course'])) {
        links.push({ name: 'courses', label: '课程', to: { name: 'courses' }, icon: 'icon-courses' })
      }

      if (this.isAuthenticated) {
        links.push({ name: 'study-groups', label: '学习小组', to: { name: 'study-groups' }, icon: 'icon-groups' })
      }

      if (hasStudentNavigation(this.studentSettings, ['progress'])) {
        links.push({ name: 'study-history', label: '学习历史', to: { name: 'study-history' }, icon: 'icon-history' })
      }

      if (this.selfTestNavVisible) {
        links.push({
          name: 'self-test-list',
          label: '课程自测',
          to: { name: 'self-test-list' },
          icon: 'icon-self-test'
        })
      }

      if (this.isAuthenticated && this.notificationEnabled && hasStudentNavigation(this.studentSettings, ['notifications'])) {
        links.push({
          name: 'notifications',
          label: '站内信',
          to: { name: 'notifications' },
          icon: 'icon-notification'
        })
      }

      links.push({ name: 'profile', label: '我的', to: { name: 'profile' }, icon: 'icon-user' })

      return links
    },
    selfTestEnabled() {
      return Boolean(this.studentSettings && this.studentSettings.self_test && this.studentSettings.self_test.enabled)
    },
    selfTestNavVisible() {
      return this.isAuthenticated && this.selfTestEnabled
    },
    notificationEnabled() {
      return !this.studentSettings || this.studentSettings.notification.enabled !== false
    },
    unreadNotificationCount() {
      return notificationState.unreadCount
    },
    displayName() {
      const profile = this.session.profile || {}
      return profile.real_name || profile.username || profile.mobile_masked || '学员'
    },
    displayNameInitial() {
      const name = this.displayName
      return name ? name.charAt(0).toUpperCase() : 'U'
    }
  },
  created() {
    if (this.session.token && !this.session.profile) {
      hydrateSession().catch(() => {})
    }

    window.addEventListener('course-auth-expired', this.handleAuthExpired)
    this.loadStudentSettings()
  },
  beforeDestroy() {
    window.removeEventListener('course-auth-expired', this.handleAuthExpired)
    this.stopUnreadPolling()
  },
  watch: {
    $route(route) {
      this.mobileMenuOpen = false
      this.loadStudentSettings(route)
    },
    isAuthenticated(value) {
      if (value) {
        this.startUnreadPolling()
      } else {
        this.stopUnreadPolling()
      }
    },
    notificationEnabled(value) {
      if (value) {
        this.startUnreadPolling()
      } else {
        this.stopUnreadPolling()
      }
    }
  },
  methods: {
    handleBack() {
      this.mobileMenuOpen = false
      if (window.history.length > 1) {
        this.$router.back()
        return
      }

      this.$router.push({ name: 'home' }).catch(() => {})
    },
    async loadStudentSettings() {
      const courseId = 0

      if (this.studentSettings && this.studentSettingsCourseId === courseId) return

      try {
        const settings = await fetchStudentSettings(courseId)
        this.studentSettings = settings
        this.studentSettingsCourseId = courseId
      } catch (error) {
        console.error('加载学生端配置失败', error)
      } finally {
        this.startUnreadPolling()
      }
    },
    startUnreadPolling() {
      if (!this.session.token || !this.notificationEnabled || this.unreadPollTimer) {
        return
      }

      loadUnreadCount().catch(() => {})
      this.unreadPollTimer = window.setInterval(() => {
        pollNotificationHasNew().catch(() => {})
      }, 3000)
    },
    stopUnreadPolling() {
      if (!this.unreadPollTimer) {
        return
      }

      window.clearInterval(this.unreadPollTimer)
      this.unreadPollTimer = null
    },
    handleAuthExpired(event) {
      const currentPath = this.$route.fullPath
      clearSession()
      setAuthDialogRedirect(currentPath)
      showAuthDialog({
        message: event && event.detail && event.detail.message
          ? event.detail.message
          : '登录已失效，请重新登录',
        redirect: currentPath
      })
    },
    handleGlobalRelogin() {
      const redirect = this.authDialog.redirect || this.$route.fullPath
      hideAuthDialog()
      clearSession()
      this.$router.replace({
        name: 'login',
        query: { redirect }
      }).catch(() => {})
    },
    async handleLogout() {
      if (this.actionPending) {
        return
      }

      this.actionPending = true

      try {
        await logoutMember()
      } catch (error) {
        console.warn(error)
      } finally {
        clearSession()
        this.actionPending = false

        if (this.$route.name !== 'home') {
          this.$router.push({ name: 'home' })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import './styles/tokens';

// 图标字体（简化版，实际项目可使用 iconfont）
.icon-home::before { content: '🏠'; }
.icon-courses::before { content: '📚'; }
.icon-groups::before { content: '👥'; }
.icon-history::before { content: '📖'; }
.icon-self-test::before { content: '✓'; }
.icon-notification::before { content: '🔔'; }
.icon-user::before { content: '👤'; }

.site-header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 100;
  background: rgba($color-surface, 0.95);
  border-bottom: 1px solid $color-border;
  backdrop-filter: blur(20px);
  box-shadow: $shadow-xs;
}

.site-header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: var(--header-height);
}

.site-header__leading {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.site-header__back {
  display: inline-flex;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.site-header__back:hover {
  opacity: 0.82;
  transform: translateX(-2px);
}

.site-header__back:focus-visible {
  outline: 2px solid rgba($color-primary, 0.42);
  outline-offset: 2px;
}

.site-header__back-icon {
  display: block;
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  transition: opacity 0.2s ease;
}

.brand:hover {
  opacity: 0.8;
}

.brand__logo {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
}

.brand__logo svg {
  width: 100%;
  height: 100%;
  display: block;
}

.brand__text {
  display: grid;
  gap: 2px;
}

.brand__text strong {
  font-size: 18px;
  font-weight: 700;
  color: $color-text-primary;
  line-height: 1.2;
  white-space: nowrap;
}

.brand__text small {
  color: $color-text-tertiary;
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
}

.menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid $color-border;
  border-radius: var(--radius-sm);
  background: $color-surface;
  cursor: pointer;
  transition: all 0.2s ease;
}

.menu-toggle:hover {
  border-color: $color-border-dark;
  background: $color-surface-hover;
}

.menu-toggle span {
  display: block;
  width: 20px;
  height: 2px;
  margin: 0 auto;
  border-radius: 2px;
  background: $color-text-primary;
  transition: all 0.3s ease;
}

.menu-toggle span.is-open:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.menu-toggle span.is-open:nth-child(2) {
  opacity: 0;
}

.menu-toggle span.is-open:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

.site-nav {
  display: flex;
  align-items: center;
  gap: 32px;
}

.site-nav__links,
.site-nav__actions {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
}

.site-nav__link {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: var(--radius-sm);
  color: $color-text-secondary;
  font-size: 15px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.site-nav__link i {
  font-style: normal;
  font-size: 16px;
}

.site-nav__link:hover {
  color: $color-primary;
  background: $color-primary-light;
}

.site-nav__link.is-active {
  color: $color-primary;
  font-weight: 600;
  background: $color-primary-light;
}

.site-nav__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: $color-danger;
  color: $color-surface;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

.user-menu {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px 6px 6px;
  border-radius: var(--radius-lg);
  background: $color-surface;
  border: 1px solid $color-border;
  transition: all 0.2s ease;
}

.user-menu:hover {
  border-color: $color-primary;
  background: $color-primary-light;
}

.user-menu__avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: $gradient-primary;
  color: $color-surface;
  font-size: 14px;
  font-weight: 600;
}

.user-menu__name {
  font-size: 14px;
  font-weight: 500;
  color: $color-text-primary;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.site-main {
  padding-top: var(--header-height);
  min-height: calc(100vh - var(--header-height));
}

.site-footer {
  background: $color-text-primary;
  color: rgba(255, 255, 255, 0.8);
  padding: 40px 0 22px;
  margin-top: 80px;
}

.site-footer__content {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) auto;
  align-items: center;
  gap: 64px;
  padding-bottom: 28px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.site-footer__brand {
  display: grid;
  gap: 18px;
  max-width: 560px;
}

.site-footer__desc {
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.6);
}

.site-footer__links {
  min-width: 430px;
}

.footer-column {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.footer-column__links {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.footer-column a {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  padding: 0 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  transition: color 0.2s ease, border-color 0.2s ease, background-color 0.2s ease;
}

.footer-column a:hover {
  border-color: rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.06);
  color: $color-surface;
}

.site-footer__bottom {
  padding-top: 18px;
  text-align: left;
}

.site-footer__bottom p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
}

@media (max-width: 1360px) {
  .menu-toggle {
    display: inline-flex;
  }

  .site-nav {
    position: absolute;
    top: calc(100% + 1px);
    right: 0;
    left: 0;
    display: none;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    padding: 16px;
    background: $color-surface;
    border-bottom: 1px solid $color-border;
    box-shadow: $shadow-md;
  }

  .site-nav.is-open {
    display: flex;
  }

  .site-nav__links,
  .site-nav__actions {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    width: 100%;
  }

  .site-nav__link {
    justify-content: flex-start;
    padding: 12px 16px;
  }

  .user-menu {
    justify-content: flex-start;
    padding: 10px 16px;
  }

  .site-footer__content {
    grid-template-columns: 1fr;
    align-items: stretch;
    gap: 28px;
  }

  .site-footer__links {
    min-width: 0;
  }

  .footer-column {
    align-items: flex-start;
  }

  .footer-column__links {
    justify-content: flex-start;
  }
}

@media (max-width: 640px) {
  .brand__text small {
    display: none;
  }

  .site-nav__link span {
    display: inline;
  }

  .site-footer {
    padding: 32px 0 20px;
    margin-top: 48px;
  }

  .site-footer__content {
    padding-bottom: 22px;
  }

  .footer-column__links {
    gap: 8px;
  }
}
</style>
